import Button from '@components/_Revamp/Button';
import {
  CheckboxListing,
  CheckListItem,
} from '@components/_Revamp/CheckboxListing';
import { TitleAndDescription } from '@components/_Revamp/TitleAndDescription/TitleAndDescription';
import { styled } from '@linaria/react';
import React, { forwardRef, useCallback, useState } from 'react';

const HealthConditionContainer = styled.div`
  max-width: 588px;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  display: none;
  margin: 200px auto 0px auto;
  @media screen and (min-width: 1250px) {
    margin: 150px auto 50px auto;
  }
`;

export interface IllessSelectionProps {
  values?: string[];
  onComplete: (e: string[]) => void;
}

export const IllessSelection = forwardRef<HTMLDivElement, any>(
  ({ values, onComplete }: IllessSelectionProps, ref) => {
    const healthConditionList: CheckListItem[] = [
      { text: 'Cancer, diabetes, stroke, AIDS or HIV infection', value: '1' },
      {
        text:
          'Heart disease (heart attack, narrowing of heart artery, disease of the heart muscle)',
        value: '2',
      },
      {
        text: 'Kidney disease (chronic kidney disease, kidney failure)',
        value: '3',
      },
      { text: 'High blood pressure', value: '4' },
      {
        text:
          'Dementia, Alzheimer’s disease, Parkinson’s disease, multiple sclerosis, motor neurone disease',
        value: '5',
      },
      {
        text:
          'Liver disease (cirrhosis, hepatitis C, liver failure, alcoholic liver disease)',
        value: '6',
      },
      {
        text:
          'Lung disease (chronic obstructive lung disease, sarcoidosis or bronchiectasis)',
        value: '7',
      },
    ];

    const [illessSelection, setIllessSelection] = useState<string[]>(values!);

    const btnFinishSelect_Clicked = () => {
      onComplete(illessSelection);
    };

    const Selection_Changed = useCallback(
      (checkedList: string[]) => {
        console.log("Checked illness list", checkedList);
        setIllessSelection(checkedList);
      },
      [],
    )


    return (
      <HealthConditionContainer ref={ref}>
        <TitleAndDescription
          title="Have you ever had"
          description="Select all that apply"
          margin="0 0 64px 0"
          padding="0"
        />
        <CheckboxListing
          checkList={healthConditionList}
          values={illessSelection}
          column={2}
          rowPerColumn={4}
          onCheckedChange={Selection_Changed}
        />
        <Button
          width={"275px"}
          label={illessSelection.length ? 'Proceed' : 'None of the above'}
          margin="66px 0 0 0"
          padding="15px 0"
          display="block"
          lineHeight="22px"
          onClick={btnFinishSelect_Clicked}
        />
      </HealthConditionContainer>
    );
  }
);
